export default __webpack_public_path__ + "static/media/4_Intro.c3b835c4.mp4";